export default __webpack_public_path__ + "static/media/luisa.4ba675a3.png";